import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/fr.ts
var add = "Ajouter";
var remove = "Supprimer";
var removeAll = "Enlever tout";
var incomplete = "Désolé, tous les champs ne sont pas remplis correctement.";
var submit = "Valider";
var noFiles = "Aucun fichier choisi";
var moveUp = "Déplacez-vous";
var moveDown = "Déplacez-vous";
var isLoading = "Chargement...";
var loadMore = "Chargez plus";
var next = "Suivant";
var prev = "Précédent";
var addAllValues = "Ajouter toutes les valeurs";
var addSelectedValues = "Ajouter les valeurs sélectionnées";
var removeAllValues = "Supprimer toutes les valeurs";
var removeSelectedValues = "Supprimer les valeurs sélectionnées";
var chooseDate = "Choisissez la date";
var changeDate = "Modifier la date";
var close = "Fermer";
var open = "Ouvrir";
var accepted = function({
  name
}) {
  return `Veuillez accepter le ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} doit être postérieure au ${date(args[0])}.`;
  }
  return `${sentence(name)} doit être dans le futur.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} ne peut contenir que des caractères alphabétiques.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} ne peut contenir que des lettres et des chiffres.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} ne peuvent contenir que des lettres et des espaces.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} doit contenir des caractères alphabétiques.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} doit contenir au moins un lettre ou nombre.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} doit contenir des lettres ou des espaces.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} doit contenir un symbole.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} doit contenir au moins une majuscule.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} doit contenir au moins une minuscule.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} doit contenir des chiffres.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} doit être un symbole.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} ne peuvent contenir que des majuscules.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} ne peut contenir que des lettres minuscules.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} doit être antérieure au ${date(args[0])}.`;
  }
  return `${sentence(name)} doit être dans le passé.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Ce champ a été configuré de manière incorrecte et ne peut pas être soumis.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} doit être comprise entre ${a} et ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} ne correspond pas.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} n'est pas une date valide, veuillez utiliser le format ${args[0]}`;
  }
  return "Ce champ a été configuré de manière incorrecte et ne peut pas être soumis.";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} doit être comprise entre ${date(args[0])} et ${date(args[1])}`;
};
var email = "Veuillez saisir une adresse email valide.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} ne se termine pas par ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} n'est pas une valeur autorisée.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} doit comporter au moins un caractère.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} doit être inférieur ou égal à ${max2} caractères.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} doit contenir ${max2} caractères.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} doit être supérieur ou égal à ${min2} caractères.`;
  }
  return `${sentence(name)} doit être comprise entre ${min2} et ${max2} caractères.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} n'est pas une valeur autorisée.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Ne peut pas avoir plus de ${args[0]} ${name}.`;
  }
  return `${sentence(name)} doit être inférieur ou égal à ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Aucun format de fichier n’est autorisé";
  }
  return `${sentence(name)} doit être du type: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Ne peut pas avoir moins de ${args[0]} ${name}.`;
  }
  return `${sentence(name)} doit être au moins de ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” n'est pas un ${name} autorisé.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} doit être un nombre.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" ou ")} est requis.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} est requis.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} ne commence pas par ${list(args)}.`;
};
var url = function() {
  return `Entrez une URL valide.`;
};
var invalidDate = `La date sélectionnée n'est pas valide.`;
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var fr_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, fr_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=fr.mjs.map